import React, { Component } from 'react';
import './App.css';
import FullGrid from './buildingblocks/FullGrid';
import Filter from './buildingblocks/Filter';
import Grid from '@mui/material/Grid';
import Banner from './buildingblocks/Banner';
import Box from '@mui/material/Box';
import AdsComponent from './buildingblocks/AdsComponent';

class App extends Component {
  state = {
    data: null,
    isLoading:true,
    filters: {
      //set these to the default values you use in the filter.js sliders
      price:500000,
      range:0,
      batterySize:0,
      numberOfSeats:0,
      typeOfCar:'All'
    },
    shuffled:false
  };

  componentDidMount() {
    this.callBackendAPI()
      .then(res => this.setState({ data: res}))
      .catch(err => console.log(err));
  }
  // fetching the GET route from the Express server which matches the GET route from server.js
  callBackendAPI = async () => {
    const response = await fetch('https://polarize.info:5000/loadCarInfo');
    const body = await response.json();

    if (response.status !== 200) {  
      throw Error(body.message) 
    }
    return body;
  };

  //grabs the values from the various filters
  handleFilterChange = input => event => {
    //timeout so it updates less regularly and is less laggy
    clearTimeout(this.sliderTimeoutId)
    this.sliderTimeoutId = setTimeout(() => {
      this.setState({
        filters: {
          //save the current state and overwrite only changed filter
          ...this.state.filters,
          [input]: event.target.value 
        }
      });
    }, 150)
  }

  render() {
    var data = this.state.data
    if (!data){
      return <div>Loading.. please wait!</div>
    }

    var shuffle = function(array) {
      let currentIndex = array.length,  randomIndex;
      // While there remain elements to shuffle.
      while (currentIndex !== 0) {
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex], array[currentIndex]];
      }    
      return array;
    }
    //Shuffle it so that manufacturers don't necessarily follow each other
    if (!this.state.shuffled) {
      shuffle(this.state.data)
      this.state.shuffled=true
    }

    return (
      <div className="App">
        <Grid container spacing={2}>
            <Grid item xs={12}>
              <Banner/>
            </Grid>
            <Grid item xs={0} md={0.25}>
              {/* empty space on the left side */}
            </Grid>
            <Grid item xs={12} md={1.5} style={{maxHeight:'100vh'}}>
              {/* Box allows scrollbar */}
              <Box overflow="auto" flex={1} flexDirection="column" display="flex" p={2} style={{height:'100%'}}>
                <Filter filterHandleFunction={this.handleFilterChange}/>
              </Box>
            </Grid>
            <Grid item xs={12} md={8.5} style={{maxHeight:'100vh',paddingBottom:'20px',minHeight:'100vh'}}>
              <Box overflow="auto" flex={1} flexDirection="column" display="flex" p={2} style={{height:'100%'}}>
                <FullGrid data={data} filters={this.state.filters}/>
              </Box>
            </Grid>
            <Grid item xs={12} md={1.75}>
            <AdsComponent dataAdSlot='3192291818' />
            </Grid>
        </Grid>
      </div>
    );
  }
}

export default App;